import { graphql } from 'gatsby';
import type { RenderRichTextData } from 'gatsby-source-contentful/rich-text';
import React from 'react';

import { Box } from '@mui/material';
import {
  useContentfulInspectorMode, useContentfulLiveUpdates
} from '../shared/hooks/contentful';

import { renderContentfulRichText } from '../shared/utils';
import { DynamicAdditionalComponent } from './dynamicAdditionalComponent';

export interface RichTextBlockProps {
  body: RenderRichTextData<null>
  contentful_id: string
  additionalComponents?: string[]
}

export default function RichTextBlock(props: RichTextBlockProps) {
  const inspectorProps = useContentfulInspectorMode();
  const data = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id },
  });

  return (
    <>
      {data.body && <Box
        {...inspectorProps({
          entryId: props.contentful_id,
          fieldId: 'title',
        })}
      >
        {renderContentfulRichText(data.body)}
      </Box>}
      {props.additionalComponents && props.additionalComponents.length > 0 ? props.additionalComponents.map(c => <DynamicAdditionalComponent key={c} id={props.contentful_id} component={c as any} />) : null}
    </>
  )
}

export const query = graphql`
  fragment RichTextBlockContent on ContentfulRichTextBlock {
    id
    body: content {
      raw
    }    
    additionalComponents
    __typename
    contentful_id       
  }
`
